import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { OrganResponse } from "app/api/iop-katalog-institucija-api-reference";
import { KucniBroj, NaseljenoMesto, Opstina } from "app/models/features/rgz/rgz.model";

export function validateSelectedDifferentValue(selectedValue1, selectedValue2): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } | null => {
    const field1ToCompare = c.get(selectedValue1)?.value;
    const field2ToCompare = c.get(selectedValue2)?.value;

    if (field1ToCompare === 0 || field2ToCompare === 0
      || field1ToCompare === null || field2ToCompare === null
      || field1ToCompare === undefined || field2ToCompare === undefined) {
      return null;
    }
    else {
      return field1ToCompare == field2ToCompare ? { testDifferent: { valid: false } } : null;
    }
  };
}

export function validationCheck(checkedValue): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } | null => {
    const fieldCheck = c.get(checkedValue)?.value;

    if (fieldCheck === null)
      return null;
    else {
      return fieldCheck === false ? { testCheched: { valid: false } } : null;
    }
  }
}

export function validateDateOrder(dateFirst, dateSecond): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } | null => {
    const field1ToCompare = c.get(dateFirst)?.value;
    const field2ToCompare = c.get(dateSecond)?.value;

    if (field1ToCompare === null || field2ToCompare === null) {
      return null;
    }
    else {
      return field1ToCompare > field2ToCompare ? { testOrder: { valid: false } } : null;
    }
  };
}

export function validateUlica(array: Array<Record<string, any>>): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.nazivCirilica?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateKucniBroj(array: KucniBroj[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.broj?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateNadlezniOrgan(array: OrganResponse[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.punNazivOrgana?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateOpstinu(array: Opstina[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.nazivCirilica?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateNaseljenoMesto(array: NaseljenoMesto[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.nazivCirilica?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateDrzava(array: Array<Record<string, any>>): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.cyrillicName?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateOJ(array: Array<Record<string, any>>): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.naziv?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateOE(array: Array<Record<string, any>>): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.punNaziv?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function validateKvalifikovaniNazivPojma(array: Array<Record<string, any>>): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control?.value;
    let filteredValues = [];
    if (!(value instanceof Array)) {
      filteredValues = array?.filter(x => x.punKvalifikovaniNaziv?.toLowerCase() == value?.toLowerCase());
    }
    if (value != "" && value != null && filteredValues?.length == 0) {
      return { 'invalidAutocompleteValue': { value: true } }
    }
    return null;
  }
}

export function exactLengthValidator(length: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && control.value.length !== length) {
      return { exactlength: { valid: false, requiredLength: length } };
    }
    return null;
  };
}

export function exactDigitsValidator(digits: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && control.value.toString().length !== digits) {
      return { exactDigits: { valid: false, requiredLength: length } };
    }
    return null;
  };
}

export function exactDecimalsValidator(decimals: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const valueString = control.value.toString();
      const decimalIndex = valueString.indexOf('.');
      
      // Check if the number has a decimal part
      if (decimalIndex !== -1) {
        const decimalPlaces = valueString.length - decimalIndex - 1;
        
        if (decimalPlaces > decimals) {
          return { exactDecimals: { valid: false, requiredLength: length } };
        }
      }
    }
    return null;
  };
}